module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_8011.c8808b97.png";